<template>
  <div
    class="alert custom-alert text-white"
    role="alert"
    :style="style"
  >
    <h5 class="alert-heading">
      {{ warning.title }}
    </h5>
    <div
      v-html="warning.content"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WarningListEntry',
  data () {
    return {
      warningId: parseInt(this.$vnode.key)
    }
  },
  computed: {
    ...mapGetters([
      'getStoredWarningById'
    ]),
    warning () {
      return this.getStoredWarningById(this.warningId)
    },
    style () {
      return {
        'background-color': this.warning.color
      }
    }
  }
}
</script>
